import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import Cookies from 'js-cookie';
import {getCurrentDomainObj} from './utils';

const middleware = [thunk];

function configureStore(initialState) {
  // Enable Redux Dev Tools extension
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

  const initState = {
    ...initialState,
    user: {
      email: Cookies.get('__email', getCurrentDomainObj()),
    }
  };

  const store = createStore(rootReducer, initState, composeEnhancers(
    applyMiddleware(...middleware)
  ));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextReducer = rootReducer;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default configureStore({});